const mailLabelTranslations: Record<string, string> = {
  "凭证": "Receipts",
  "待回复": "Awaiting Reply",
  "项目": "Projects",
};

export function displayMailLabelName(name: string) {
  const normalized = name.trim();
  return mailLabelTranslations[normalized] ?? normalized;
}
